import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { Link, Navigate, useParams } from 'react-router-dom';
import { useAuth } from './auth/AuthContext';
import { orderPaymentCustomerSummary } from './account/orderPaymentDisplay';

export default function OrderInvoicePage() {
  const { orderNumber } = useParams();
  const { ready, isAuthed, getOrderDetail } = useAuth();
  const [order, setOrder] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!ready || !isAuthed || !orderNumber) return;
    (async () => {
      const res = await getOrderDetail(orderNumber);
      if (!res.ok) setError(res.error || 'Order not found.');
      else setOrder(res.order);
    })();
  }, [ready, isAuthed, orderNumber, getOrderDetail]);

  useEffect(() => {
    if (order) window.print();
  }, [order]);

  if (!ready) return null;
  if (!isAuthed) return <Navigate to={`/login?next=/account/invoice/${orderNumber}`} replace />;

  return (
    <div className="store-page account-invoice-page">
      <Helmet>
        <title>Receipt {orderNumber} | Saloni Designs</title>
      </Helmet>
      <div className="container store-page__container py-4">
        <p className="d-print-none mb-3">
          <button type="button" className="btn btn-outline-secondary btn-sm me-2" onClick={() => window.print()}>
            Print
          </button>
          <Link to="/account">Back to account</Link>
        </p>
        {error ? <p className="text-danger">{error}</p> : null}
        {order ? (
          <div className="account-invoice-print">
            <h1 className="h4">Saloni Designs</h1>
            <p className="mb-1">
              <strong>Order #{order.order_number}</strong>
            </p>
            <p className="small text-muted">
              {order.created_at ? new Date(order.created_at).toLocaleString('en-IN') : ''}
            </p>
            {(() => {
              const pay = orderPaymentCustomerSummary(order);
              if (!pay) return null;
              return (
                <div className="account-invoice-payment small mb-2">
                  <p className="mb-1">
                    <strong>{pay.headline}</strong>
                    <span className="text-muted"> ({pay.badge})</span>
                  </p>
                  {pay.subline ? <p className="text-muted mb-1">{pay.subline}</p> : null}
                  {pay.paidAt ? (
                    <p className="mb-1">
                      Paid {new Date(pay.paidAt).toLocaleString('en-IN')}
                    </p>
                  ) : null}
                  {pay.reference ? (
                    <p className="mb-0">
                      {pay.referenceLabel}: <span className="fw-semibold">{pay.reference}</span>
                    </p>
                  ) : null}
                </div>
              );
            })()}
            <hr />
            <p className="small mb-1">{order.shipping?.name}</p>
            <p className="small mb-1">{order.shipping?.address}</p>
            <p className="small mb-3">
              {order.shipping?.city}, {order.shipping?.state} {order.shipping?.pincode}
            </p>
            <table className="table table-sm">
              <tbody>
                {(order.items || []).map((it, i) => (
                  <tr key={i}>
                    <td>
                      {it.product_name} × {it.quantity}
                    </td>
                    <td className="text-end">₹{Number(it.line_total).toFixed(0)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            <p className="fw-semibold text-end mb-0">Total: ₹{Number(order.total_amount).toFixed(0)}</p>
          </div>
        ) : null}
      </div>
    </div>
  );
}
